import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function CancelPage() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6 py-20">
      <div className="w-full max-w-md text-center">
        <XCircle className="h-10 w-10 mx-auto text-gray-400" />
        <h2
          className="font-heading text-3xl text-gray-900 mt-6"
          data-testid="payment-cancel-message"
        >
          Payment Cancelled
        </h2>
        <p className="text-sm text-gray-500 font-body mt-3">
          Your payment was cancelled. No charges have been made to your account.
        </p>
        <p className="text-xs text-gray-400 font-body mt-2">
          If you experienced any issues, please don't hesitate to contact us.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/events">
            <Button
              className="h-11 px-6 rounded-sm bg-[#1a2e4a] text-white font-body text-sm"
              data-testid="payment-cancel-retry-button"
            >
              <RotateCcw className="h-4 w-4 mr-2" />
              Try Again
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="h-11 px-6 rounded-sm border-gray-200 font-body text-sm">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Go Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
